import styled from 'styled-components';

export enum SystemMessageType {
  DEFAULT = `default`,
  WIDGET = `widget`,
}

export const ContextMenuWrapper = styled.div`
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0),
    0 6px 7px 0 rgba(151, 210, 206, 0.22), 0 0.5px 0.5px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;

  font-family: Eesti, sans-serif;
  font-size: 1.4rem;
  color: #a6afb8;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  && * {
    user-select: none;
  }
`;

export const ContextMenuItem = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;

  &:hover {
    color: black;
  }

  &:active {
    color: #858d94;
  }

  transition: color 0.2s ease-in-out;
`;

export function shouldShowContextMenu(
  messageType?: SystemMessageType,
): boolean {
  if (SystemMessageType.WIDGET === messageType) return true;
  return false;
}
